import { Injectable, inject } from '@angular/core';
import { FormlyUserAdapter } from '@intalio/formly-builder';
import { AuthService } from '../services/auth.service';

@Injectable()
export class AvsecUserAdapter extends FormlyUserAdapter {
  private auth = inject(AuthService);

  getCachedUser(): Record<string, any> | null {
    const user = this.auth.getCurrentUser();
    return user ? (user as unknown as Record<string, any>) : null;
  }
}
